import { NzTableFilterFn, NzTableFilterList, NzTableSortFn } from 'ng-zorro-antd/table';

export const CLUB_CODES = [
  'sfr',
  'ten',
  'ind',
  'mia',
  'tbb',
  'hou',
  'nyg',
  'nep',
  'car',
  'was',
  'chi',
  'cle',
  'nos',
  'lac',
  'den',
  'jax',
  'lvr',
  'det',
  'atl',
  'bal',
  'pit',
  'nyj',
  'phi',
  'sea',
  'buf',
  'gbp',
  'min',
  'ari',
  'kcc',
  'lar',
  'cin',
  'dal',
] as const;

export const MARKET_CODES = [
  'fra',
  'gha',
  'nga',
  'esp',
  'col',
  'gbr',
  'deu',
  'irl',
  'nzl',
  'aus',
  'bra',
  'kor',
  'ita',
  'jpn',
  'arg',
  'are',
  'aut',
  'grc',
  'che',
] as const;

export const MARKET_NAMES = [
  'Argentina',
  'Australia',
  'Austria',
  'Brazil',
  'Colombia',
  'France',
  'Germany',
  'Ghana',
  'Greece',
  'Ireland',
  'Italy',
  'Japan',
  'Korea (the Republic of)',
  'New Zealand',
  'Nigeria',
  'Spain',
  'Switzerland',
  'United Arab Emirates (the)',
  'United Kingdom of Great Britain and Northern Ireland (the)',
] as const;

export const CHANNEL_TYPE_CODES = ['email_banner', 'onepass_push', 'email_dedicated', 'onepass_widget'] as const;

export const QUOTA_TYPE_CODES = ['favteamnongmp', 'favteam', 'allfans', 'nofavteam'] as const;

export const QUOTA_ENTITY_NAMES = [
  'San Francisco 49ers',
  'Tennessee Titans',
  'Indianapolis Colts',
  'Miami Dolphins',
  'Tampa Bay Buccaneers',
  'Houston Texans',
  'New York Giants',
  'New England Patriots',
  'Carolina Panthers',
  'Washington Commanders',
  'Chicago Bears',
  'Cleveland Browns',
  'New Orleans Saints',
  'Los Angeles Chargers',
  'Denver Broncos',
  'Jacksonville Jaguars',
  'Las Vegas Raiders',
  'Detroit Lions',
  'Atlanta Falcons',
  'Baltimore Ravens',
  'Pittsburgh Steelers',
  'New York Jets',
  'Philadelphia Eagles',
  'Seattle Seahawks',
  'Buffalo Bills',
  'Green Bay Packers',
  'Minnesota Vikings',
  'Arizona Cardinals',
  'Kansas City Chiefs',
  'Los Angeles Rams',
  'Cincinnati Bengals',
  'Dallas Cowboys',
] as const;

export const AUDIENCE_SEGMENT_LABELS: Readonly<Record<string, string>> = {
  nofavteam: 'No Fav Team',
  favteamnongmp: 'Non GMP Fav Team',
  allfans: 'All Fans',
  favteam: 'Fav Team',
};

export type AllocationColumnKey =
  | 'club_code'
  | 'interaction_market_name'
  | 'interaction_market_code'
  | 'channel_type_code'
  | 'quota_type_code'
  | 'total_quota_count'
  | 'quota_used';

export interface AllocationColumnDefinition {
  key: AllocationColumnKey;
  label: string;
  searchable?: boolean;
  filterable?: boolean;
  staticFilters?: readonly string[];
  width?: string;
}

export interface AllocationColumn extends AllocationColumnDefinition {
  filters: NzTableFilterList;
  filterFn: NzTableFilterFn<Record<string, unknown>> | null;
  sortFn: NzTableSortFn<Record<string, unknown>>;
}

export const ALLOCATION_COLUMNS: readonly AllocationColumnDefinition[] = [
  { key: 'club_code', label: 'Club', staticFilters: CLUB_CODES },
  { key: 'interaction_market_name', label: 'Market', staticFilters: MARKET_NAMES },
  { key: 'interaction_market_code', label: 'Market Code', staticFilters: MARKET_CODES },
  { key: 'channel_type_code', label: 'Channel', staticFilters: CHANNEL_TYPE_CODES },
  { key: 'quota_type_code', label: 'Audience Segment', staticFilters: QUOTA_TYPE_CODES },
  { key: 'total_quota_count', label: 'Available Allocations', filterable: false },
  { key: 'quota_used', label: 'Allocations Used', filterable: false },
];

export const allocationValueCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
